import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReleaseCommentDialogComponent } from './release-comment-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
    ],
    exports: [ReleaseCommentDialogComponent],
    declarations: [ReleaseCommentDialogComponent],
    providers: [],
})
export class ReleaseCommentDialogModule { }
